export default __webpack_public_path__ + "static/media/calender-time.711bbc78.svg";